import type { Route } from "./+types/explore";
import { redirect } from "react-router";
import { migrateOldUrlToNewFormat } from "../../src/routing/urlMigration";
import VisApp from "../../src/visualization/index";

export async function clientLoader({ request }: Route.ClientLoaderArgs) {
  const url = new URL(request.url);
  const { needsMigration, migratedParams } = migrateOldUrlToNewFormat(
    url.searchParams,
  );
  if (needsMigration) {
    throw redirect(`${url.pathname}?${migratedParams.toString()}`);
  }
  return null;
}

export default function ExploreLayout() {
  return <VisApp />;
}
